import { Option, Select, TextInput } from '@d-edge/overnight-hotelier-react'
import { Field } from '@/components/ui/Field'
import { Check } from './Check'
import { NumberInput } from './NumberInput'
import { DAYS, TIME_ZONES, type RuleDraft } from './scalability'
import styles from './ScalabilityDialog.module.css'

interface ScheduleFieldsProps {
  rule: RuleDraft
  position: number
  onChange: (patch: Partial<RuleDraft>) => void
}

export function ScheduleFields({ rule, position, onChange }: ScheduleFieldsProps) {
  const id = `rule-${rule.key}`
  // A time zone loaded from the API but absent from the short list stays selectable instead of being replaced.
  const timeZones = TIME_ZONES.includes(rule.timeZone) ? TIME_ZONES : [...TIME_ZONES, rule.timeZone]
  const toggleDay = (day: string, checked: boolean) => onChange({ days: checked ? [...rule.days, day] : rule.days.filter((d) => d !== day) })

  return (
    <>
      <div className={styles.fieldGrid}>
        <Field label="Instances" htmlFor={`${id}-instances`}>
          <NumberInput id={`${id}-instances`} min={0} value={rule.instances} onChange={(instances) => onChange({ instances })} />
        </Field>
        <Field label="Time zone">
          <Select fullWidth value={rule.timeZone} onChange={(timeZone) => onChange({ timeZone })}>
            {timeZones.map((zone) => (
              <Option key={zone} value={zone} label={zone} />
            ))}
          </Select>
        </Field>
        <Field label="From">
          <TextInput fullWidth value={rule.from} placeholder="00:00:00" onChange={(e) => onChange({ from: e.target.value })} />
        </Field>
        <Field label="To">
          <TextInput fullWidth value={rule.to} placeholder="00:00:00" onChange={(e) => onChange({ to: e.target.value })} />
        </Field>
      </div>
      <div role="group" aria-label={`Days of rule ${position}`} className={styles.days}>
        {DAYS.map((day) => (
          <Check key={day} checked={rule.days.includes(day)} onChange={(checked) => toggleDay(day, checked)}>
            {day}
          </Check>
        ))}
      </div>
    </>
  )
}
